import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "full-width nav-account" }

import { computed } from "vue";
import { useRoute } from "vue-router";
import { NavOption } from "@/types";
import { FEEDBACK_LINK } from "@/util";
import { orgStore, permissionStore, sessionStore } from "@/hooks";
import { Routes } from "@/router";
import { ListItem } from "@/components/common";
import SavingIcon from "./SavingIcon.vue";
import Notifications from "./Notifications.vue";


/**
 * Renders the navigation drawer.
 */
const __default__ = {
  name: "NavAccount",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentRoute = useRoute();

const options = computed<NavOption[]>(() => [
  {
    label: "My Organization",
    icon: "organization",
    subtitle: orgStore.org.name,
    path: Routes.ORG,
    color: Routes.ORG === currentRoute.path ? "primary" : "text",
    tooltip: "My Organization: " + orgStore.org.name,
  },
  {
    label: "My Account",
    subtitle: sessionStore.userEmail,
    icon: "account",
    path: Routes.ACCOUNT,
    color: Routes.ACCOUNT === currentRoute.path ? "primary" : "text",
    tooltip: "My Account: " + sessionStore.userEmail,
  },
  ...(permissionStore.isSuperuser
    ? [
        {
          label: "Admin Controls",
          icon: "admin",
          path: Routes.ADMIN,
          color: permissionStore.isSuperuserActive ? "primary" : "text",
          class: permissionStore.isSuperuserActive ? "bd-primary" : "",
          tooltip: "Admin Controls",
        } as NavOption,
      ]
    : []),
]);

/**
 * Routes the user to the feedback page.
 */
function handleFeedback(): void {
  window.open(FEEDBACK_LINK);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ListItem), {
      title: "",
      to: ""
    }, {
      icon: _withCtx(() => [
        _createVNode(SavingIcon)
      ]),
      _: 1
    }),
    _createVNode(_unref(ListItem), {
      to: "",
      title: "Send Feedback",
      icon: "feedback",
      clickable: "",
      tooltip: "Send Feedback",
      onClick: handleFeedback
    }),
    _createVNode(Notifications),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
      return (_openBlock(), _createBlock(_unref(ListItem), {
        key: option.label,
        color: option.color,
        icon: option.icon,
        subtitle: option.subtitle,
        title: option.label,
        to: option.path,
        tooltip: option.tooltip,
        class: _normalizeClass(option.class),
        "action-cols": 2
      }, null, 8, ["color", "icon", "subtitle", "title", "to", "tooltip", "class"]))
    }), 128))
  ]))
}
}

})